import { TableCell, tableCellClasses } from '@mui/material';
import styled from '@emotion/styled';

export const StyledTableCell = styled(TableCell)({
  textAlign: 'left',
  whiteSpace: 'nowrap',
  border: 'none',
  width: 'fit-content',

  [`&.${tableCellClasses.head}`]: {
    fontSize: '15px',
    fontWeight: 500,
    padding: '20px 15px 7px 15px',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: '15px',
    fontWeight: 500,
    cursor: 'pointer',
    padding: '27px 15px 27px 15px',
  },
});

export default StyledTableCell;
